import { render } from "./SecondChoicePage.vue?vue&type=template&id=5fcf6394&scoped=true"
import script from "./SecondChoicePage.vue?vue&type=script&lang=js"
export * from "./SecondChoicePage.vue?vue&type=script&lang=js"

import "./SecondChoicePage.vue?vue&type=style&index=0&id=5fcf6394&lang=scss&scoped=true"

import exportComponent from "/home/forge/vienaiespeja.on-forge.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fcf6394"]])

export default __exports__